import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface commonState {
  isInit: boolean;
  tablePage: number;
  tableRowsPerPage: number;
  menuSelected?: string;
  menuOpen?: string;
  drawerOpen?: boolean;
}

const initialState: commonState = {
  isInit: true,
  tablePage: 1,
  tableRowsPerPage: 5,
  menuSelected: localStorage.getItem("lastPath") || "/home",
  drawerOpen: true,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setTablePage: (state, action: PayloadAction<number>) => {
      state.tablePage = action.payload;
    },
    setTableRowsPerPage: (state, action: PayloadAction<number>) => {
      state.tableRowsPerPage = action.payload;
    },
    setMenuSelected: (state, action: PayloadAction<string | undefined>) => {
      state.menuSelected = action.payload;
    },
    setMenuOpen: (state, action: PayloadAction<string | undefined>) => {
      state.menuOpen = action.payload;
    },
    setDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.drawerOpen = action.payload;
    },
    resetCommonState: () => initialState,
  },
});

export const {
  resetCommonState,
  setTablePage,
  setTableRowsPerPage,
  setMenuSelected,
  setMenuOpen,
  setDrawerOpen,
} = commonSlice.actions;

export default commonSlice.reducer;
